export default __webpack_public_path__ + "static/ssv-kroschke-bd1a2803eca4566d02181c136d1f03df.jpg";